export default function PageNumber({ pageNumber, totalPages }) { return <span aria-label={`Page ${pageNumber} sur ${totalPages}`}>{pageNumber} / {totalPages}</span>; }
